import { IPROP_MAP, modifyProps } from '../../generators/modifyProps';

import { JDSSelectorButtonProps } from './generated';
import { forwardRef } from 'react';

const legacyKinds = ['tertiary-narrow'] as const;
type legacyKindsType = (typeof legacyKinds)[number];

const legacyAppearance = ['grey-scale'] as const;
type legacyAppearanceType = (typeof legacyAppearance)[number];

const legacySizes = ['extra-large'] as const;
type legacySizesType = (typeof legacySizes)[number];

export interface SelectorButtonProps
  extends Omit<JDSSelectorButtonProps, 'kind' | 'appearance' | 'size'> {
  kind?: JDSSelectorButtonProps['kind'] | legacyKindsType;
  iconPosition?: 'left' | 'right';
  disabled?: boolean;
  appearance?: legacyAppearanceType | JDSSelectorButtonProps['appearance'];
  selected?: boolean;
  size?: legacySizesType | JDSSelectorButtonProps['size'];
  stretch?: boolean;
  label?: string;
  icon?: string | JSX.Element;
  /**
   * @deprecated
   * use `text` prop
   */
  children?: React.ReactNode;
}

export const PROP_MAP: IPROP_MAP<SelectorButtonProps> = (props) => {
  if (props.size === 'extra-large') {
    console.warn('extra-large size is deprecated. use `extra_large`');
  }
  if (props.appearance === 'grey-scale') {
    console.warn('grey-scale appearance is deprecated. use `grey_scale`');
  }
  if (props.kind === 'tertiary-narrow') {
    console.warn(
      'tertiary-narrow prop of kind is deprecated. Use `tertirary_narrow`'
    );
  }
  return {
    appearance: {
      properties: {
        appearance: props.appearance
      },
      variations: {
        'grey-scale': {
          appearance: 'grey_scale'
        },
        contrast: {
          appearance: 'contrast'
        },
        normal: {
          appearance: 'normal'
        }
      }
    },
    size: {
      properties: {
        size: props.size
      },
      variations: {
        medium: {
          size: 'medium'
        },
        small: {
          size: 'small'
        },
        large: {
          size: 'large'
        },
        'extra-large': {
          size: 'extra_large'
        }
      }
    },
    label: {
      properties: {
        text: props.label
      }
    },
    children: {
      properties: {
        text: props.children
      }
    },
    icon: {
      properties: {
        icon: props.icon
      }
    },
    kind: {
      properties: {
        kind: props.kind
      },
      variations: {
        primary: {
          kind: 'primary'
        },
        secondary: {
          kind: 'secondary'
        },
        tertiary: {
          kind: 'tertiary'
        },
        'tertiary-narrow': {
          kind: 'tertiary_narrow'
        }
      }
    }
  };
};

export const withLogic = (
  Component: React.ComponentType<SelectorButtonProps>
): React.FC<SelectorButtonProps> =>
  forwardRef<HTMLButtonElement, SelectorButtonProps>(
    (userProps: SelectorButtonProps, ref) => {
      const props = modifyProps(userProps, PROP_MAP);

      return (
        <Component
          {...{
            ...props,
            _hasText: Boolean(props.text?.length || props?.children),
            rootRef: ref
          }}
        />
      );
    }
  );
